export default function ResultBody({children, ...props}) {

    return (
        <tbody {...props}>
        {children}
        </tbody>
    )
}